export default __webpack_public_path__ + "static/AgrandirGrandHeavy-08497067afe7d28222f67ad5eba5942f.woff";